import {
  CMS_CONTRACT_CLICK_OPEN_ORDERSLIP,
  HeadToHeadCardStyle,
  CMS_MARKET_RUNTIME,
} from '../cms-config';
import { initials } from '../cms-market-helpers';
import { buildHeadToHead } from './h2h-model';

export default {
  inject: { cmsRuntime: { from: CMS_MARKET_RUNTIME } },
  props: {
    settings: { type: Object, required: true },
    chartRecords: { type: Array, default: () => [] },
  },
  data() {
    return { failedImages: {}, HeadToHeadCardStyle };
  },
  computed: {
    opensOrderSlip() {
      return CMS_CONTRACT_CLICK_OPEN_ORDERSLIP;
    },
    market() {
      return this.cmsRuntime.markets[Number(this.settings.market?.id)];
    },
    tile() {
      return buildHeadToHead(this.settings, this.market, this.$store.state.app.settingShowOdds);
    },
    sides() {
      return this.tile ? [this.tile.left, this.tile.right] : [];
    },
    incumbents() {
      return this.sides.filter((side) => side.isIncumbent);
    },
    marketLink() {
      return {
        name: 'market-details',
        params: { marketId: this.market.marketId, marketUrl: this.market.marketUrl },
      };
    },
  },
  methods: {
    isTradeDisabled(side) {
      const contract = this.market.contracts.find((item) => item.contractId === side.id);
      return this.opensOrderSlip && !this.cmsRuntime.canTrade(this.market, contract);
    },
    trade(side, event) {
      if (!CMS_CONTRACT_CLICK_OPEN_ORDERSLIP) {
        this.$router.push({ ...this.marketLink, query: { contractId: side.id } });
        return;
      }
      const contract = this.market.contracts.find((item) => item.contractId === side.id);
      if (!this.cmsRuntime.canTrade(this.market, contract)) return;
      this.cmsRuntime.openOrder({
        marketId: this.market.marketId,
        contractId: side.id,
        direction: 'yes',
        priceCents: side.buyPrice,
        contractImageUrl: side.image,
        trigger: event.currentTarget,
      });
    },
    initials,
  },
};
